import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-metric-sats',
  templateUrl: './metric-sats.component.html',
  styleUrls: ['./metric-sats.component.scss'],
})
export class MetricSatsComponent implements OnInit {
  @Input() stats: any[] = [];
  @Output() emitStats = new EventEmitter();
  public selected = '';

  constructor() { }

  ngOnInit() {}

  showMetric(stat){
    if(stat.id === 'viewWeb'){
      return false;
    }
    this.selected = stat.id;
    this.emitStats.emit(stat.id);
  }
}
